import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import BackNav from "@/components/BackNav";

export default function AltriServizi() {
  const { user } = useAuth();

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 space-y-8" data-testid="page-altri-servizi">
      <BackNav />

      <div className="space-y-4">
        <p className="eyebrow mb-2">Servizio</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-navy">Altri servizi dedicati</h1>
        <p className="text-body leading-relaxed">
          Ogni situazione è diversa. Se hai un'esigenza particolare — una ricorrenza importante,
          un intervento fuori dall'ordinario o una richiesta specifica — raccontacela:
          valuteremo insieme come aiutarti e, quando necessario, prepareremo un preventivo dedicato.
        </p>
      </div>

      <div className="card-ivory p-8 space-y-4">
        <HeartHandshake className="text-[#4a7c59]" size={28} />
        <p className="text-sm text-body leading-relaxed">
          Scrivici la tua richiesta nel campo note al momento dell'ordine, oppure contattaci:
          rispondiamo con attenzione e senza fretta. Per gli interventi più impegnativi è prevista
          una valutazione con preventivo prima di procedere.
        </p>
        <Link to={user ? "/checkout?type=singola&pulizia=specialistica" : "/accedi"} data-testid="altri-cta" className="btn-primary">
          Invia la tua richiesta <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
}
